query ContractPaymentShow($id: ID!) {
  contractPayment(id: $id) {
    id
    contractId
    contract {
      id
      title
      currency
      invoiceCurrency
    }
    organizationId
    organization {
      id
      title
    }
    periodFrom
    periodTo
    invoiceDate
    expiredAt
    paidAt
    status
    expired
    note
    invoiceUrl
    invoice {
      number
      issuedAt
      sentAt
      sentTo
      previousNumbers {
        number
        issuedAt
        reason
      }
    }
    amount {
      value
      currency
    }
    amountInOrganizationCurrency {
      value
      currency
    }
    exchangeRate {
      rate
      date
      source
    }
    invoiceAmount {
      value
      currency
    }
    invoiceExchangeRate {
      rate
      date
      source
    }
    lines {
      itemType
      title
      amount {
        value
        currency
      }
      amountInOrganizationCurrency {
        value
        currency
      }
      reportId
      report {
        id
        period
        status
      }
    }
  }
}
